import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  inject,
  input,
  output,
  signal,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../../presentation/icon/icon.component';
import { CopyDirective } from '../../../directives/copy.directive';
import { UiControlDirective } from '../../../directives/ui/ui-control.directive';
import {
  ISectionSettings,
  SectionSettings,
  UTILS,
} from '@aksia/infrastructure';
import { UiLoadingDirective } from '../../../directives/ui/ui-loading.directive';
import { UiContentComponentDirective } from '../../../directives/ui/ui-content-component.directive';
@Component({
  selector: 'section',
  imports: [
    CommonModule,
    IconComponent,
    CopyDirective,
    UiLoadingDirective,
    RouterOutlet,
  ],
  templateUrl: './section.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [
    {
      directive: UiContentComponentDirective,
      inputs: ['uicontentcomponent', 'uicontentinput'],
    },
    {
      directive: UiLoadingDirective,
      inputs: ['uiloading: sectionloading'],
    },
  ],
})
export class SectionComponent extends UiControlDirective {
  //#region Injections

  protected readonly contentDir = inject(UiContentComponentDirective);
  protected readonly loadingDir = inject(UiLoadingDirective);

  //#endregion

  //#region Inputs/Outputs

  override settings = input<SectionSettings, ISectionSettings>(
    new SectionSettings(),
    {
      transform: (settings: ISectionSettings) => this.initSettings(settings),
    },
  );

  titleCssClass = input<string>();
  onToggle = output<boolean>();

  //#endregion

  //#region Host Bindings

  @HostBinding('class.isMinimized')
  get isMinimized() {
    return this.settings().isMinimized;
  }
  // Signal to control visibility
  isRemoved = signal(false);
  //#endregion

  //#region View Children

  @ViewChild('UiSectionCodeContent', { read: ViewContainerRef })
  uiSectionCodeContent!: ViewContainerRef;

  //#endregion

  //#region Functions

  constructor() {
    super();
    this.loadingDir.silenced.set(true);
  }

  protected override initSettings(settings: ISectionSettings) {
    let sectionSettings = UTILS.OBJECT.assign(new SectionSettings(), settings);
    super.initSettings(sectionSettings);
    return sectionSettings;
  }

  protected toggle() {
    if (!this.settings().isCollapsible) {
      return;
    }

    this.settings().isMinimized = !this.settings().isMinimized;
    this.onToggle.emit(this.settings().isMinimized ?? false);
  }

  protected close(event: MouseEvent) {
    event.stopPropagation();
    this.isRemoved.set(true);
    this.onToggle.emit(true);
  }

  //#endregion
}
